/**
 * @typedef {object} StatsSetFilterItemPayload
 * @property {string} filterItem
 * @property {string[]} value
 */

/**
 * @param {any} draft - Draft state.
 * @param {StatsSetFilterItemPayload} payload - Action payload.
 */
export const setFilterItem = (draft, payload) => {
    const { filterItem, value } = payload;
    draft.filters[filterItem] = value;
};
